/** @format */
import { commonSharedModule, planRangeDirectiveModule } from 'sis-components';
(function () {
  angular.module('student.plan.rules.header', [planRangeDirectiveModule, 'pascalprecht.translate', commonSharedModule]);
})();